import { createFileRoute } from '@tanstack/react-router'

import {Authorisation} from "@/lib/auth/components/auth-provider";
import Unauthorized from "@/lib/auth/components/unauthorized";
import {PERMISSIONS} from "@/lib/auth/roles";
import BulkInviteCreate from "@/modules/bulk-invite/create";
import {BULK_INVITE_CREATE_PATH, BULK_INVITE_CREATE_URL} from "@/utils/urls";

export const Route = createFileRoute(BULK_INVITE_CREATE_PATH)({
  component: RouteComponent,
  beforeLoad: () => {
    return {
      breadcrumbs: [
        {label: 'Invite feedback', path: '#'},
        {label: 'Send invites', path: BULK_INVITE_CREATE_URL},
      ],
      children: <div className={'h-10'}></div>
    }
  }
})


function RouteComponent() {
  return (
    <div className={'flex flex-col items-center justify-center'}>
      <Authorisation
        roles={[]}
        permissions={[PERMISSIONS.IS_FIRM_WIEW_OR_IS_NETWORK_VIEW_ON_NETWORK]}
        forbiddenFallback={<Unauthorized/>}>
        <BulkInviteCreate/>
      </Authorisation>
    </div>
  )
}
